<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent1">Thanks to all my family members who offered words of wisdom and encouragement. Special thanks to fellow Doyle family members who had first review of drafts and thoughts and guidance: Terry, Vicki and Mike.</p>
<p class="indent">Thanks also to my first-read cousin, Mary Alice, for bearing the brunt of first passes in all the gyrations.</p>
<p class="indent">Thanks to <a href="http://Ancestry.com" target="_blank">Ancestry.com</a> and <a href="http://Newspapers.com" target="_blank">Newspapers.com</a> for their invaluable sources and research capabilities that guided this work.</p>
<p class="indent">Finally, thanks to all the kingpins who provided valuable inspiration for achievement.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?9f7a5f74